function getEnvVariable(key: string): string | undefined {
  return window._env_[key] || process.env[key];
}

function getRequiredEnvVariable(key: string): string {
  const value = window._env_[key] || process.env[key];

  if (typeof value === 'undefined') {
    console.error(key);
    throw new Error('env variable is not set');
  }

  return value;
}

export const WELL_STATUS_SOCKET_URL = getRequiredEnvVariable('REACT_APP_WELL_STATUS_SOCKET_URL');
export const SESSION_MANAGEMENT_SOCKET_URL = getRequiredEnvVariable('REACT_APP_SESSION_MANAGEMENT_SOCKET_URL');
export const WELL_DIRECTORY_SERVICE_API_URL = getRequiredEnvVariable('REACT_APP_WELL_DIRECTORY_SERVICE_API_URL');
export const DASHBOARD_SERVICE_API_URL = getRequiredEnvVariable('REACT_APP_DASHBOARD_SERVICE_API_URL');
export const API_GOSTORAGE_URL = getRequiredEnvVariable('REACT_APP_GOSTORAGE_API_URL');
export const API_GOSTORAGE_WELL_LOGS_URL = getRequiredEnvVariable('REACT_APP_GOSTORAGE_WELL_LOGS_API_URL');
export const API_USER_FILES_URL = getRequiredEnvVariable('REACT_APP_USER_FILES_API_URL');
export const API_LEGACY_CACHE_URL = getRequiredEnvVariable('REACT_APP_CACHE_URL');
export const API_WEBSOCKET_CACHE_PATH = getRequiredEnvVariable('REACT_APP_CACHE_WEBSOCKET_URL') ?? '';
export const API_WEBSOCKET_OPERATIONS_PATH = getRequiredEnvVariable('REACT_APP_OPERATIONS_WEBSOCKET_URL') ?? '';
export const AUTH_API_URL = getRequiredEnvVariable('REACT_APP_AUTH_API_URL') ?? '';
export const AUTH_TOKEN = getRequiredEnvVariable('REACT_APP_AUTH_TOKEN') ?? '';
export const LIBRARIES_URL = getEnvVariable('REACT_APP_DEVELOP_LIBRARIES_URL') ?? '';
export const IS_REPORT_AVAILABLE = getEnvVariable('REACT_APP_IS_REPORT_AVAILABLE') === 'true' ? true : false;
// export const WELL_DETAILS_AVAILABLE = getEnvVariable('REACT_APP_WELL_DETAILS_AVAILABLE') === 'true' || false;
export const WELL_DETAILS_AVAILABLE = false;
export const WELL_ANALYSE_AVAILABLE = getEnvVariable('REACT_APP_WELL_ANALYSE_AVAILABLE') === 'true' || false;
export const DAY_DEPTH_AVAILABLE = getEnvVariable('REACT_APP_DAY_DEPTH_AVAILABLE') === 'true' || false;
export const WELL_LOGS_MANAGER_AVAILABLE = getEnvVariable('REACT_APP_WELL_LOGS_MANAGER_AVAILABLE') === 'true' || false;
export const IMAGE_BROADCAST_AVAILABLE = getEnvVariable('REACT_APP_IMAGE_BROADCAST_AVAILABLE') === 'true' || false;
export const OPERATIONAL_PARAMETERS_AVAILABLE =
  getEnvVariable('REACT_APP_OPERATIONAL_PARAMETERS_AVAILABLE') === 'true' || false;
export const DIRECTIONAL_DRILLING_AVAILABLE =
  getEnvVariable('REACT_APP_DIRECTIONAL_DRILLING_AVAILABLE') === 'true' || false;
export const OPERATIONS_LOG_TRACK_AVAILABLE =
  getEnvVariable('REACT_APP_OPERATIONS_LOG_TRACK_AVAILABLE') === 'true' || false;
export const EXPORT_CSV_AVAILABLE = getEnvVariable('REACT_APP_EXPORT_CSV_AVAILABLE') === 'true' || false;
export const VIDEOBROADCAST_AVAILABLE = getEnvVariable('REACT_APP_VIDEO_BROADCAST_AVAILABLE') === 'true' || false;
export const DEV_SETTINGS_PAGE_AVAILABLE = getEnvVariable('REACT_APP_DEV_SETTINGS_PAGE_AVAILABLE') === 'true' || false;
export const SPLIT_RANGE_TIME_IN_SECONDS = getEnvVariable('REACT_APP_SPLIT_RANGE_TIME_IN_SECONDS') || 15;
export const SPLIT_RANGE_DEPTH = getEnvVariable('REACT_APP_SPLIT_RANGE_DEPTH') || 5;
export const SHOW_GO_REPORT_CHARTS = getEnvVariable('REACT_APP_SHOW_GO_REPORT_CHARTS') === 'true' || false;
export const GO_REPORT_API_URL = getEnvVariable('REACT_APP_GO_REPORT_API_URL') || undefined;
export const HEATMAP_AVAILABLE = getEnvVariable('REACT_APP_HEATMAP_AVAILABLE') === 'true' || false;
